module.exports = __webpack_public_path__ + "img/988814a.png";